/**
 * Permission names as people read them (DESIGN_SYSTEM.md §5 Permissions →
 * Copy). The Roles grant screen shows a resource row and an action column;
 * any copy that asks a member to get a permission names it the same way, in
 * quotes, so the admin can find the checkbox. The raw key
 * (`lenses:make_public`) is for code and never appears in the UI.
 */

/** 'processor_template_versions' → 'Processor Template Versions'. */
export function resourceLabel(resource: string): string {
  return resource
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/** 'make_public' → 'Make public'. */
export function actionLabel(action: string): string {
  const words = action.replace(/_+/g, ' ').trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/** 'lenses:make_public' → 'Lenses: Make public'. A key with no colon is returned unchanged. */
export function permissionLabel(key: string): string {
  const colon = key.indexOf(':');
  if (colon === -1) return key;
  return `${resourceLabel(key.slice(0, colon))}: ${actionLabel(key.slice(colon + 1))}`;
}
